// True when running inside the Tauri shell rather than the plain web build.
//
// This replaced a `navigator.userAgent.indexOf('Electron')` sniff. Tauri injects
// `__TAURI_INTERNALS__` into the page before any app code runs, so this is a
// direct capability check rather than a guess from a string the platform is free
// to change.
export const isDesktop = () =>
	typeof window !== "undefined" && "__TAURI_INTERNALS__" in window;
